import { route } from "~/helpers/routeHelper";
import Meeting from "~/pages/Meeting/index";
import { TRoute } from "~/types/global";

const publicRoutes: TRoute[] = [];

const protectedRoutes: TRoute[] = [
  { path: route('start_meeting'), component: Meeting },
];

export { publicRoutes, protectedRoutes }
